import { render, staticRenderFns } from "./LoginPausado.vue?vue&type=template&id=1f181a30&scoped=true&"
import script from "./LoginPausado.vue?vue&type=script&lang=js&"
export * from "./LoginPausado.vue?vue&type=script&lang=js&"
import style0 from "./LoginPausado.vue?vue&type=style&index=0&id=1f181a30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f181a30",
  null
  
)

export default component.exports